 export const queryParam = {
    onlyParent: "parent=true"
};